import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Building2, Warehouse, Wrench, Shield, Layers, Sun } from 'lucide-react';

const iconMap = {
  Building2,
  Warehouse,
  Wrench,
  Shield,
  Layers,
  Sun,
};

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-[#0f172a]">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="heading-2 text-[#60a5fa] mb-4">{t.services.title}</h2>
          <p className="body-large text-[#94a3b8] max-w-3xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={index}
                className="bg-[#1e293b] p-8 border border-[#1e40af] hover:border-[#60a5fa] transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-[#60a5fa] rounded-full flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-[#0f172a]" />
                </div>
                <h3 className="heading-4 text-[#60a5fa] mb-4">{service.title}</h3>
                <p className="body-small text-[#94a3b8]">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
